import { House, CircleDollarSign, Users, ShoppingCart, Clipboard, BookOpen } from 'lucide-react';

export const navItems = [
  {
    heading: 'Main',
    icon: House,
    links: [
      { label: 'Users', path: '/home' },
    ],
  },
  {
    heading: 'Quotes',
    icon: CircleDollarSign,
    links: [
      { label: 'Quotes Data', path: '/quotes' },
      { label: 'Create New Quote', path: '/new-quote' },
    ],
  },
  {
    heading: 'Customers',
    icon: Users,
    links: [
      { label: 'Customer Data', path: '/customers' },
    ],
  },
  {
    heading: 'Products',
    icon: ShoppingCart,
    links: [
      { label: 'Product Data', path: '/product' },
      { label: 'Saw Data', path: '/saw' },
      // { label: 'Saw Product', path: '/productsaw' },
      { label: 'Master Price List', path: '/master-price-list' },
      { label: 'Modular Conveyor', path: '/modularConveyor' },
    ],
  },
  {
    heading: 'Reports',
    icon: Clipboard,
    links: [
      { label: 'Sales Report', path: '/reports/sales' },
    ],
  },
  {
    heading: 'Help',
    icon: BookOpen,
    links: [
      { label: 'User Guide', path: '/help' },
    ],
  },
];

export const dropmenuitems = {
  title: "User Name",
  items: [
    { label: "Profile", href: "/profile" },
    { label: "Account Settings & Security", href: "/settings" },
    { label: "Logout", href: "/login", color: "red" },
  ]
}
